import { get, intersection, isEmpty, startsWith } from 'lodash';

import { getSubdomain, replaceSubdomainInLocation } from 'utils';

import { SCOPES } from 'constants/roles';
import { PATH, PAGES } from 'constants/url';

import { Base64Decode, Base64Encode } from 'utils/base64';

export default {
  data() {
    return {
      SUBDOMAN_REDIRECT: process.env.SUBDOMAN_REDIRECT,
    };
  },
  methods: {
    loginWithToken(token) {
      if (!token) throw new Error('Token missing!');

      this.$auth.token('default', token);

      this.$auth.fetch({
        params: {},
        success: () => {
          this.redirectLogin();
        },
        error: (error) => {
          throw error;
        },
      });
    },
    redirectLogin(redirect) {
      this.$nextTick(() => {
        const user = this.$auth.user();
        const token = this.$auth.token();
        const scope = get(user, 'scope', []);

        let name = PAGES.PARTICIPANT.HOME;

        if (!isEmpty(intersection(SCOPES.STAFF, scope))) {
          name = PAGES.PROFESSIONAL.HOME;
        }

        // After login reload subscribed plan
        this.$store.dispatch('GetInstanceSubscribedPlanSummarized');

        // Set user preffered language
        const locale = get(user, 'preferred_language', this.$locale.default());
        this.$locale.change(locale);

        const redirectDecoded = !isEmpty(redirect) ? Base64Decode(redirect) : null;

        // console.log('redirectLogin gate 4');

        // console.log('in redirectLogin user token', user, token);
        this.replaceOrRedirectToSubdomain({ name }, redirectDecoded, token);
      });
    },
    redirectLogout(name) {
      this.$nextTick(() => {
        this.$router.push({ name });
      });
    },
    replaceOrRedirectToSubdomain(route, redirectDecoded, token) {
      const user = this.$auth.user();
      const userSubdomain = get(user, 'subdomain');

      console.log('SUBDOMAN_REDIRECT', this.SUBDOMAN_REDIRECT, this.SUBDOMAN_REDIRECT === true);

      const instanceSubdomain = getSubdomain();

      // console.log('replaceOrRedirectToSubdomain', route, redirectDecoded, token, userSubdomain, instanceSubdomain);

      if (this.SUBDOMAN_REDIRECT && userSubdomain && instanceSubdomain && userSubdomain !== instanceSubdomain) {
        const location = replaceSubdomainInLocation(userSubdomain);

        const resolved = this.$router.resolve(route);
        const href = get(resolved, 'href');

        const url = (location && href) ? (token ? `${location}${href}?token=${token}` : `${location}${href}`) : null;

        // console.log('url', url);

        if (url) {
          this.$auth.logout();
          window.location.replace(url);
        }
      } else if (redirectDecoded) this.$router.replace(redirectDecoded);
      else this.$router.replace(route);
    },
    getRedirectPath(auth, user, roles) {
      const path = get(this.$route, 'path', '');
      const name = get(this.$route, 'name');
      const params = get(this.$route, 'params', {});
      const query = get(this.$route, 'query', {});
      const scope = get(user, 'scope', []);

      const redirect = Base64Encode({ name, params, query });

      const userIsStaff = intersection(SCOPES.STAFF, scope).length > 0;
      const namePageHome = userIsStaff ? PAGES.PROFESSIONAL.HOME : PAGES.PARTICIPANT.HOME;

      // console.log('getRedirectPath', path, auth, user, roles, userIsStaff);

      // Set user locale
      const locale = get(user, 'preferred_language');
      if (locale) this.$locale.change(locale);

      let route = null;

      const notify = get(this.$route, 'meta.notify');
      let notification = null;

      // case 1 - auth is undefined, page can access public or logged
      // action - do not redirect
      if (auth === undefined) route = null;

      // case 2 - auth is false, user should not be logged
      // action - redirect to landing with message
      if (auth === false && !isEmpty(user)) {
        route = {
          name: namePageHome,
        };

        notification = {
          title: 'label.error_403_title',
          message: 'label.error_403_text',
        };
      }

      // case 3 - auth is true, user should be logged
      // action - redirect user to login if not logged
      if ((auth === true || !isEmpty(roles)) && isEmpty(user)) {
        let name = null;

        if (startsWith(path, PATH.PROFESSIONAL) || startsWith(path, PATH.PARTICIPANT)) {
          name = startsWith(path, PATH.PROFESSIONAL) ? PAGES.PROFESSIONAL.LOGIN : PAGES.PARTICIPANT.LOGIN;
        }

        route = {
          name,
          query: { redirect },
        };
      }

      // case 4 - auth is true and there is required roles
      // action - redirect user to home with message that page is forbiden (if logged but not authorised)
      if (!isEmpty(user) && !isEmpty(roles) && !this.$auth.check(roles)) {
        route = {
          name: namePageHome,
        };

        notification = {
          title: 'label.error_403_title',
          message: 'label.error_403_text',
        };
      }

      if (notify && notification) {
        this.$notify({
          title: this.$t(notification.title),
          message: this.$t(notification.message),
          type: 'error',
        });
      }

      if (route) {
        // console.log('getRedirectPath', route);
        this.replaceOrRedirectToSubdomain(route);
      }
    },
    redirectAuthorisationRequired() {
      const auth = get(this.$route, 'meta.auth');
      const roles = get(this.$route, 'meta.auth.roles', []);

      // if token is present in query auto-login
      const token = get(this.$route, 'query.token');
      if (token) {
        this.$auth.token('default', token);
      }

      this.$auth.fetch({
        params: {},
        success: () => {
          // console.log('gate 1');
          const user = this.$auth.user();
          this.getRedirectPath(auth, user, roles);
        },
        error: () => {
          // console.log('gate 2');
          this.getRedirectPath(auth, null, roles);
        },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/redirect-logged.js